import React, { useState } from 'react';
import { Image } from "lucide-react";

interface InputBarProps {
  onSend: (text: string) => void;
  disabled: boolean;
  noVizSelected?: boolean;
  onLatestVisualization?: () => void;
}

export default function InputBar({ onSend, disabled, noVizSelected = false, onLatestVisualization }: InputBarProps) {
  const [input, setInput] = useState<string>('');

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!input.trim()) return;
    onSend(input);
    setInput('');
  };

  return (
      <form onSubmit={handleSubmit} className="p-3 border-t-2 border-uiBackground bg-chatBackground-light dark:bg-chatBackground-dark flex items-center gap-2">
        {onLatestVisualization && !noVizSelected && (
          <button
            type="button"
            onClick={onLatestVisualization}
            className="h-12 w-12 flex items-center justify-center bg-primary-light dark:bg-primary-dark text-white rounded hover:bg-secondary-dark dark:hover:bg-secondary-light"
            aria-label="Latest Visualization"
          >
            <Image size={28} />
          </button>
        )}
        <input
        type="text"
        className="flex-1 p-3 border border-uiBackground rounded-l-lg bg-chatBackground-light dark:bg-chatBackground-dark text-text-light dark:text-text-dark placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-primary-light dark:focus:ring-primary-dark"
        value={input}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setInput(e.target.value)}
        placeholder={noVizSelected ? "Please create or select a visualization..." : "Type a message..."}
        disabled={disabled || noVizSelected}
      />
      <button
        type="submit"
        className="h-12 bg-primary-light dark:bg-primary-dark text-white px-4 rounded-r-lg hover:bg-secondary-dark dark:hover:bg-secondary-light"
        disabled={disabled || noVizSelected}
      >
        Send
      </button>
    </form>
  );
}
